export default {
  common: {
    customize: "Custom period",
    day: "Today",
    thisMonth: "This Month",
    thisWeek: "This Week",
    thisYear: "This Year",
    thisQuarter: "This Quarter",
    today: "Today",
    week: "Week",
    month: "Month",
    quarter: "Quarter",
    year: "Year",
    all: "All",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    search: "Search...",
    noResults: "No results found",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    close: "Close",
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    success: "Success",
    completed: "Completed",
    inProgress: "In Progress",
    todayAt: "Today at {{time}}",
    yesterdayAt: "Yesterday at {{time}}",
    tomorrowAt: "Tomorrow at {{time}}",
    copy: "Copy",
    copied: "Copied!",
    expand: "Expand",
    shrink: "Shrink",
    tooManyChanges: "Too many changes",
  },
  notifications: {
    viewAll: "View all",
    title: "Notifications",
  },
  welcome: "Welcome to {{appName}}",
  nav: {
    home: "Home",
    about: "About",
    contact: "Contact",
  },
  buttons: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
  },
  auth: {
    codeSentTo: "Code has been sent to ",
    appName: "PlanifAI",
    tagline: "Master the present, build your future",
    validationCode: "Validation Code",
    validate: "Validate",
    backToLogin: "Back to Login",
    enterValidationCode: "Please enter the verification code we sent to your email.",
    validateAccount: "Validate Account",
    resendCode: "Resend Code",
    resendCodeIn: "Resend code in {{seconds}}s",
  },
  login: {
    title: "Login",
    email: "Email",
    password: "Password",
    submit: "Sign In",
    loading: "Signing in...",
    error: "Login error",
    genericError: "Error signing in",
    orContinueWith: "Or continue with",
    noAccount: "Don't have an account?",
    signUp: "Sign up",
    providers: {
      google: "Google",
      apple: "Apple",
    },
    validateAccount: "Validar Cuenta",
    enterValidationCode: "Por favor, ingresa el código de verificación que enviamos a tu correo.",
    validationCode: "Código de validación",
    validate: "Validar",
    backToLogin: "Volver al inicio de sesión"
  },
  register: {
    title: "Create Account",
    fullName: "Full name",
    email: "Email",
    password: "Password",
    submit: "Create Account",
    loading: "Creating account...",
    error: "Registration error",
    genericError: "Registration failed",
    haveAccount: "Already have an account?",
    signIn: "Sign in",
    accept: "I accept the",
    terms: "Terms and Conditions",
    acceptTermsError: "You must accept the Terms and Conditions"
  },

  forgotPassword: {
    title: "Reset Password",
    description: "Enter your email and we'll send you a link to reset your password",
    emailPlaceholder: "Email",
    submit: "Send Reset Link",
    loading: "Sending link...",
    backToLogin: "Back to Login",
    success: "If an account exists for this email, you will receive a password reset link",
    error: "Password reset error",
    genericError: "Failed to send reset link",
  },

  navbar: {
    title: "PlanifAI",
    darkMode: "Toggle dark mode",
    logout: "Logout",
    loggingOut: "Logging out...",
    language: "Change language",
  },
  navigation: {
    home: "Home",
    journal: "Journal",
    goals: "Goals",
    profile: "Profile",
  },
  profile: {
    title: "My Profile",
  },
  userDetails: {
    title: "Account Details",
    name: {
      label: "Name",
      notSpecified: "Not specified",
    },
    email: {
      label: "Email",
      notSpecified: "Not specified",
    },
    joined: {
      label: "Joined",
      notSpecified: "Not specified",
    },
    premium: {
      label: "Premium",
      notSpecified: "Not specified",
    },
    status: {
      verified: "Verified",
      pending: "Pending verification",
    },
    security: {
      verified: "Your account is verified",
      verifyEmail: "Verify your email address",
    }
  },
  userProfile: {
    title: "Personal Information",
    biography: {
      label: "Biography",
      placeholder: "Tell us a bit about yourself...",
    },
    expectations: {
      label: "What do you hope to achieve with Stoic?",
      placeholder: "Your goals and expectations...",
    },
    edit: "Edit",
    save: "Save",
    error: "Failed to update profile",
    autoSaveHint: "Auto-saving",
    characters: "characters",
    unsavedChanges: "You have unsaved changes",
    allChangesSaved: "All changes saved",
    saveChanges: "Save changes",
  },

  settings: {
    morningNotifications: 'Morning Notifications',
    eveningNotifications: 'Evening Notifications',
    notificationPreferences: 'Notification Preferences',
    title: "Settings",
    darkMode: "Dark mode",
    language: "Language",
    notifications: "Notifications",
    languages: {
      en: "English",
      es: "Spanish",
      fr: "French",
    },
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    error: "Failed to update settings",
  },
  home: {
    stats: {
      streak: {
        title: "Current Streak",
        unit: "days",
        weekTrend: "+2 this week",
      },
      challenges: {
        title: "Completed Challenges",
        progress: "40% completed",
      },
    },
    moodChart: {
      title: "Weekly Mood",
    },
  },
  weeklyHighlights: {
    title: "Weekly Achievements",
    highlights: {
      streak: {
        title: "Longest streak",
        description: "7 consecutive days of reflection",
      },
      achievement: {
        title: "Achievement unlocked",
        description: "Completed 5 stoic challenges",
      },
      goal: {
        title: "Goal reached",
        description: "Daily meditation for 1 week",
      },
    },
  },
  challenges: {
    title: "Upcoming Challenges",
    items: {
      negativeVisualization: {
        title: "Negative Visualization",
        description: "Practice the art of anticipating adversities",
      },
      dailyGratitude: {
        title: "Daily Gratitude",
        description: "Find 3 things to be grateful for",
      },
      morningMeditation: {
        title: "Morning Meditation",
        description: "10 minutes of reflection upon waking",
      },
    },
  },
  subscription: {
    title: "Subscription",
    plans: {
      free: "Free Plan",
      premium: "Premium",
    },
    features: {
      ai: "Unlimited AI mentor access",
      challenges: "Exclusive premium challenges",
      stats: "Advanced statistics",
      reminders: "Custom reminders",
      ads: "Ad-free experience",
    },
    upgrade: "Upgrade to Premium",
  },
  quickActions: {
    shortcuts: 'Pro tip: Use Alt+1 through Alt+2 for quick access',
    dailyChallenge: "Daily Challenge",
    newGoal: "New Goal",
    aiConsult: "Consult AI",
    viewJournal: "View Journal",
  },
  journal: {
    title: "My Journal",
    edit: "Edit",
    cancelEdit: "Cancel editing",
    saveSuccess: "Saved successfully",
    updateSuccess: "Updated successfully",
    saveError: "Error saving entry",
    validation:{
      pleaseFillAllFields: "Please fill all fields"
    },
    tabs: {
      morning: "Morning",
      evening: "Evening",
    },
    analysis: {
      title: "Analysis & Tips",
      observations: "Observations",
      tomorrowSuggestions: "Suggestions for tomorrow"
    },
    metrics: {
      mood: "Mood",
      energy: "Energy Level",
      motivation: "Motivation",
      accomplishment: "Day's Achievements",
      reflection: "Reflection Level",
    },
    prompts: {
      morning: {
        gratitude: "What am I grateful for today?",
        intention: "What is my main intention for the day?",
      },
      evening: {
        learnings: "What have I learned today?",
        improvements: "What could I improve tomorrow?",
      },
    },
    placeholder: "Write your reflection here...",
    saveButton: "Save Reflection",
    noEntry: "No entry for this time of day.",
    noReflection: "No reflection",
    editButton: "Edit",
    clickToExpand: "Click to expand",
  },
  goals: {

    title: "My Goals",
    newGoal: "New Goal",
    emptyState: "You haven't created any goals yet. Create your first goal!",
    search: "Search goals...",
    overview: {
      completed: "Completed",
      goals: "Goals",
    },
    duration: {
      all: "All",
      short: "Short-term",
      medium: "Medium-term",
      long: "Long-term",
    },
    status: {
      all: "All",
      completed: "Completed",
      inProgress: "In Progress",
    },
    sort: {
      newest: "Newest",
      oldest: "Oldest",
      mostProgress: "Most Progress",
      leastProgress: "Least Progress",
    },
    stats: {
      averageProgress: "Average Progress",
      completedTasks: "Completed Tasks",
      inProgressGoals: "in Progress Goals",
    },
    progress: {
      label: "Progress",
    },
    tasks: {
      label: "Tasks",
    },
    daysRemaining: {
      label: "Days Remaining",
    },
    lastUpdated: "Last updated on ",
    wizard: {
      success: "Goal created successfully!",
      title: "Create New Goal",
      submitting: "Creating your goal...",
      steps: {
        duration: {
          title: "Duration",
          description: "Select the time horizon for your goal"
        },
        dates: {
          title: "Dates",
          description: "Define the period to achieve your goal"
        },
        details: {
          title: "Details",
          description: "Describe your goal and steps to achieve it"
        }
      },
      durations: {
        short: {
          label: "Short term",
          description: "Quick, focused goals to boost your motivation"
        },
        medium: {
          label: "Medium term",
          description: "Objectives requiring planning and consistent commitment"
        },
        long: {
          label: "Long term",
          description: "Deep transformations marking significant change"
        }
      },
      dates: {
        startDate: "Start Date",
        endDate: "End Date"
      },
      details: {
        titleLabel: "Goal Title",
        titlePlaceholder: "Enter a concise goal title",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Describe the steps to achieve your goal"
      },
      errors: {
        dates: {
          startAfterEnd: "Start date must be before end date"
        },
        details: {
          emptyTitle: "Please enter a title for your goal",
          emptyDescription: "Please describe your goal details"
        },
        submission: "Error creating the goal. Please try again."
      },
      buttons: {
        previous: "Previous",
        next: "Next",
        submit: "Create Goal"
      }
    },
  },
  streakStats: {
    title: "Daily Streak",
    days: "days",
    longestStreak: "Longest streak",
    consistencyLevel: "Consistency Level",
    lastActivity: "Last activity",
    daysAgo: "days ago",
    viewDetails: "View details",
    detailsTitle: "Streak Details",
    currentStreak: "Current streak",
    achievements: "Achievements",
    level: "Level",
    history: "Streak History",
    period: "Period",
    duration: "Duration",
    completionByDay: "Completion by day",
    totalStats: "Total Statistics",
    totalTasksCompleted: "Total tasks completed",
    resetStreak: "Reset streak",
    confirmReset: "Are you sure you want to reset your streak? This action cannot be undone.",
    noData: "No streak data available",
    noHistory: "No previous streak history",
    lastCompletedOn: "Last activity: {{date}}",
    noCompletedTasks: "No completed tasks yet",
    levels: {
      beginner: "Beginner",
      consistent: "Consistent",
      dedicated: "Dedicated",
      master: "Master"
    }
  },
  stats: {
    totalGoals: "Total Goals",
    completedGoals: "Completed Goals",
    onTrackGoals: "On-Track Goals",
    behindGoals: "Behind Schedule Goals",
    goalsLabel: "goals",
    completedLabel: "completed",
    inProgressLabel: "in progress",
    behindLabel: "behind",
    aboveExpected: "above expected",
    belowExpected: "below expected",
    daysRemaining: "Days remaining",
    completedTasks: "Completed tasks",
    completedMilestones: "Completed milestones",
    overdueTasks: "Overdue tasks"
  },
  examples: {
    exampleGoal: "Example Goal",
    learnReactNative: "Learn React Native",
    completeTypeScriptCourse: "Complete TypeScript Course",
    personalProject: "Personal Project"
  },
  moodChart: {
    noDataYet: "No mood data yet",
    noDataTitle: "No mood data available",
    createEntry: "Create a mood entry",
    emptyStates: {
      week: "No mood data for this week",
      month: "No mood data for this month",
      all: "No mood data available",
    },
    title: "Mood Tracking",
    noData: "No data",
    notRecorded: "Not recorded",
    average: "Average",
    frequentMood: "Frequent Mood",
    trend: "Trend",
    records: "Records",
    distribution: "Mood distribution",
    improved: "Improved",
    decreased: "Decreased",
    noChange: "No change",
    toggleStats: "Show/hide statistics",
    toggleDistribution: "Show/hide distribution",
    clickForDetails: "Click on the dots to see more details about your mood",
    noDataAvailable: "No data available for this period",
    levels: {
      veryLow: "Very Low",
      low: "Low",
      neutral: "Neutral",
      good: "Good",
      excellent: "Excellent"
    },
    descriptions: {
      veryLow: "Difficult day",
      low: "Below normal",
      neutral: "Balanced",
      good: "Above normal",
      excellent: "Exceptional day"
    },
    tips: {
      veryLow: "Consider activities that relax you",
      low: "Small achievements can improve your day",
      neutral: "Good time to plan",
      good: "Take advantage of your positive energy",
      excellent: "Reflect on what worked today"
    },
    trends: {
      improving: "Improving",
      worsening: "Worsening",
      stable: "Stable"
    }
  },
  calendar: {
    weekDays: {
      sunday: "Su",
      monday: "Mo",
      tuesday: "Tu",
      wednesday: "We",
      thursday: "Th",
      friday: "Fr",
      saturday: "Sa"
    },
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December"
    },
    confirmButton: "Confirm"
  },
} as const;
